module.exports = __webpack_public_path__ + "img/joyskit-lg.c126ba74.png";